import Fade from 'react-reveal/Fade';

export default function Hero() {
	return (
		<Fade>
			<div id="Hero" className="pt-8 overflow-hidden sm:pt-12 lg:relative lg:py-32">
				<div className="mx-auto max-w-md px-4 sm:max-w-3xl sm:px-6 lg:px-8 lg:max-w-7xl lg:grid lg:grid-cols-2 lg:gap-24">
					<div>
						<div>
							<img className="h-20 w-auto" src={process.env.PUBLIC_URL + '/logo.png'} alt="Workflow" />
						</div>

						<div className="mt-20">
							<div className="mt-6 sm:max-w-xl">
								<h1 className="text-4xl font-extrabold text-gray-900 tracking-tight sm:text-5xl">
									The easy way to <span className="text-rose-500">organize</span> and{' '}
									<span className="text-rose-500">protect</span> your entire music catalog{' '}
									<span className="text-rose-500">in minutes.</span>
								</h1>
								<p className="mt-6 text-xl text-gray-500">
									We help creators and musicians manage their rights on YouTube. We provide the right
									tools and assistance to optimally monetise your digital content.
								</p>
							</div>
						</div>
					</div>
				</div>
				<div className="sm:mx-auto sm:max-w-3xl sm:px-6">
					<div className="py-12 sm:relative sm:mt-12 sm:py-16 lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2">
						<div className="hidden sm:block">
							<div className="absolute inset-y-0 left-1/2 w-screen bg-gray-50 rounded-l-3xl lg:left-80 lg:right-0 lg:w-full" />
							<svg
								className="absolute top-8 right-1/2 -mr-3 lg:m-0 lg:left-0"
								width={404}
								height={392}
								fill="none"
								viewBox="0 0 404 392"
							>
								<defs>
									<pattern
										id="837c3e70-6c3a-44e6-8854-cc48c737b659"
										x={0}
										y={0}
										width={20}
										height={20}
										patternUnits="userSpaceOnUse"
									>
										<rect
											x={0}
											y={0}
											width={4}
											height={4}
											className="text-gray-200"
											fill="currentColor"
										/>
									</pattern>
								</defs>
								<rect width={404} height={392} fill="url(/yummu837c3e70-6c3a-44e6-8854-cc48c737b659)" />
							</svg>
						</div>
						<div className="relative pl-4 -mr-40 sm:mx-auto sm:max-w-3xl sm:px-0 lg:max-w-none lg:h-full lg:pl-12">
							<img
								className="w-full rounded-md lg:h-full lg:w-auto lg:max-w-none"
								src={process.env.PUBLIC_URL + '/onlinead.png'}
								alt=""
							/>
						</div>
					</div>
				</div>
			</div>
		</Fade>
	);
}
